// Cloned from @wandb/ui 0.1.0 as part of removing the @wandb/ui dependency.
// Intentional differences from the original:
// - @font-face rules (GlobalFontStyles) are omitted; those fonts are already
//   provided globally by common/css/Base.less.
// - Only the MUI theme is provided. The legacy foundations palette is not
//   exposed through styled-components' theme context: components that need it
//   import `foundations` directly, and styled-components consumers that read
//   `props.theme` wrap themselves in their own local ThemeProvider. App and
//   Weave share one styled-components runtime, so a root-level styled theme
//   would leak into every App styled component.
import {ThemeProvider as MUThemeProvider} from '@mui/material/styles';
import React, {useMemo} from 'react';

import {useColorMode} from '../../../../util/useColorMode';
import {DarkTheme} from './material-ui/dark-theme/dark-theme';
import {LightTheme} from './material-ui/light-theme/light-theme';

const themeMap = {
  light: LightTheme,
  dark: DarkTheme,
};

/**
 * Uses React context to inject a theme for your W&B app.
 */
export const ThemeProvider: React.FC<{
  theme?: keyof typeof themeMap;
  children?: React.ReactNode;
}> = ({theme, children}) => {
  const {isDarkMode} = useColorMode();
  const muTheme = useMemo(
    () =>
      theme == null ? themeMap[isDarkMode ? 'dark' : 'light'] : themeMap[theme],
    [isDarkMode, theme]
  );

  return <MUThemeProvider theme={muTheme}>{children}</MUThemeProvider>;
};
